import { advisoryResultFormLoadRequested } from 'state/advisory/actions';
import type { Thunk } from 'state/state.common';
import { workspaceAdvisoryTabCreated } from 'state/workspaces/workspace.actions';
import { getWorkspaceActiveTabId } from 'state/workspaces/workspaces/workspaces.selector';

export function loadFormWithAdvisoryResultThunk(basket: string[]): Thunk<void> {
  return (dispatch, getState, { getNewGuid, selectors: { getStaticFormQuoteId } }) => {
    const workspaceType = 'static';

    const state = getState();
    const tabId = getWorkspaceActiveTabId(state, workspaceType);

    if (tabId === undefined) {
      return;
    }

    const quoteId = getStaticFormQuoteId(state, tabId);

    if (quoteId === undefined) {
      return;
    }

    const newTabId = getNewGuid();

    dispatch(workspaceAdvisoryTabCreated(newTabId, workspaceType, 'quote'));
    dispatch(advisoryResultFormLoadRequested(newTabId, quoteId, basket));
  };
}
